import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import template from './NewFeature.rt';
import * as actions from './NewFeatureActions';
import {
  getActiveFeatureGroupImageStyle
} from '../../ProjectScope/ProjectScopeSelector';

const MapStateToProps = (state) => {
  return {
    imageStyle: getActiveFeatureGroupImageStyle(state)
  };
}

const MapDispatchToProps = (dispatch, props) => {
  return {
    showNewFeature: () => !props.disabled && dispatch(actions.showNewFeatureOverlay(true, props.group))
  };
}

class NewFeatureClass extends PureComponent {
  render = template;
}

const connector = connect(MapStateToProps, MapDispatchToProps);
const NewFeature = connector(NewFeatureClass);

export { NewFeature };
export default NewFeature;

